import { render, staticRenderFns } from "./inquiry_submit.vue?vue&type=template&id=5d1bf7d7&scoped=true"
import script from "./inquiry_submit.vue?vue&type=script&lang=js"
export * from "./inquiry_submit.vue?vue&type=script&lang=js"
import style0 from "./inquiry_submit.vue?vue&type=style&index=0&id=5d1bf7d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1bf7d7",
  null
  
)

export default component.exports